import { createSlice } from '@reduxjs/toolkit';
import { materials } from 'helpers/globals';
import { getItemIndexById, getCurrentGroup, getLargestId } from 'helpers/utils';

const INIT_STATE = {
  settings: {
    color: materials.soneva.colors.sand,
    railDirection: 'horizontal',
    railColor: 'dark',
  },
  readyForCalculation: false,
  currentGroupId: 1,
  groups: [
    {
      id: 1,
      settings: {
        maxWidth: 1000,
        slopeSizeCm: 0,
        slopeDirection: 'asc',
        readyToDesign: false,
      },
      elements: [],
    }
    /*{
      id: 1,
      settings: {
        maxWidth: 1000,
        slopeSizeCm: 0,
        slopeDirection: 'asc',
        readyToDesign: true,
      },
      elements: [
        {
          id: 1,
          name: 'column',
          brickCountHorizontally: 3,
          brickCountVertically: 8,
        },
        {
          id: 2,
          name: 'fundament',
          brickCountHorizontally: 10,
          brickCountVertically: 3,
        },
        {
          id: 3,
          name: 'column',
          brickCountHorizontally: 2,
          brickCountVertically: 8,
        },
        {
          id: 4,
          name: 'door',
          cmHorizontally: 90,
          type: 'simple',
        },
        {
          id: 5,
          name: 'column',
          brickCountHorizontally: 2,
          brickCountVertically: 8,
        },
        {
          id: 6,
          name: 'fundament',
          brickCountHorizontally: 10,
          brickCountVertically: 3,
        },
        {
          id: 7,
          name: 'column',
          brickCountHorizontally: 2,
          brickCountVertically: 8,
        },
        {
          id: 8,
          name: 'door',
          cmHorizontally: 286,
          type: 'double',
        },
        {
          id: 9,
          name: 'column',
          brickCountHorizontally: 3,
          brickCountVertically: 8,
        },
      ],
    },
    {
      id: 2,
      settings: {
        maxWidth: 600,
        slopeSizeCm: 50,
        slopeDirection: 'asc',
        readyToDesign: true,
      },
      elements: [
        {
          id: 1,
          name: 'column',
          brickCountHorizontally: 2,
          brickCountVertically: 8,
        },
        {
          id: 2,
          name: 'fundament',
          brickCountHorizontally: 10,
          brickCountVertically: 3,
        },
        {
          id: 3,
          name: 'column',
          brickCountHorizontally: 1,
          brickCountVertically: 8,
        },
        {
          id: 4,
          name: 'door',
          cmHorizontally: 93,
          type: 'simple',
        },
        {
          id: 5,
          name: 'column',
          brickCountHorizontally: 1,
          brickCountVertically: 8,
        },
        {
          id: 6,
          name: 'fundament',
          brickCountHorizontally: 10,
          brickCountVertically: 3,
        },
        {
          id: 7,
          name: 'column',
          brickCountHorizontally: 2,
          brickCountVertically: 8,
        },
      ],
    },*/
  ],
};

const addNewGroupHandler = (state) => {
  const largestId = getLargestId(state.groups);

  state.groups.push({
    id: largestId + 1,
    settings: {
      maxWidth: 1000,
      slopeSizeCm: 0,
      slopeDirection: 'asc',
      readyToDesign: false,
    },
    elements: [],
  });

  state.currentGroupId = largestId + 1;
};

const removeGroupHandler = (state, groupIndex) => {
  state.groups.splice(groupIndex, 1);
  state.currentGroupId = getLargestId(state.groups);

  if (state.groups.length < 1) {
    addNewGroupHandler(state);
  }
};

const addNewElementHandler = (state, { insertAfterId, element }) => {
  const { elements } = getCurrentGroup(state);

  if (insertAfterId) {
    const elementIndexById = getItemIndexById(elements, insertAfterId);
    if (elementIndexById === -1) return;

    elements.splice(elementIndexById + 1, 0, element);
  } else {
    elements.push(element);
  }
};

const editElementHandler = (state, { index, element }) => {
  const { elements } = getCurrentGroup(state);
  elements[index] = element;
};

const removeElementHandler = (state, elementIndex) => {
  const { elements } = getCurrentGroup(state);
  elements.splice(elementIndex, 1);
};

const editPropHandler = (state, { prop, value }) => {
  state[prop] = value;
};

const editSettingsPropHandler = (state, { prop, value }) => {
  state.settings[prop] = value;
};

const editGroupSettingsPropHandler = (state, { prop, value }) => {
  const { settings } = getCurrentGroup(state);
  settings[prop] = value;
};
const editElementPropHandler = (state, { index, prop, value }) => {
  const { elements } = getCurrentGroup(state);
  elements[index][prop] = value;
};

const fenceSlice = createSlice({
  name: 'fence',
  initialState: INIT_STATE,
  reducers: {
    addNewGroup: (state) => addNewGroupHandler(state),
    removeGroup: (state, action) => removeGroupHandler(state, action.payload),
    addNewElement: (state, action) => addNewElementHandler(state, action.payload),
    editElement: (state, action) => editElementHandler(state, action.payload),
    removeElement: (state, action) => removeElementHandler(state, action.payload),
    editProp: (state, action) => editPropHandler(state, action.payload),
    editSettingsProp: (state, action) => editSettingsPropHandler(state, action.payload),
    editGroupSettingsProp: (state, action) => editGroupSettingsPropHandler(state, action.payload),
    editElementProp: (state, action) => editElementPropHandler(state, action.payload),
  },
});

export const {
  addNewGroup,
  removeGroup,
  addNewElement,
  editElement,
  removeElement,
  editProp,
  editSettingsProp,
  editGroupSettingsProp,
  editElementProp,
} = fenceSlice.actions;

export default fenceSlice.reducer;
